import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
// Only import and use "containers" for your route
import { routes } from '../../constants/routes';
import Associations from '../../containers/AssociationsPage';
import CommentsPage from '../../containers/CommentsPage';
import ContactsPage from '../../containers/ContactsPage';
import PlaybooksPage from '../../containers/PlaybooksPage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function PortalRoutes() {
  const {
    path
  } = useRouteMatch();
  return /*#__PURE__*/_jsxs(Switch, {
    children: [/*#__PURE__*/_jsx(Route, {
      path: `${path}${routes.contacts}`,
      component: ContactsPage
    }), /*#__PURE__*/_jsx(Route, {
      path: `${path}${routes.associations}`,
      component: Associations
    }), /*#__PURE__*/_jsx(Route, {
      path: `${path}${routes.comments}`,
      component: CommentsPage
    }), /*#__PURE__*/_jsx(Route, {
      path: `${path}${routes.playbooks}`,
      component: PlaybooksPage
    }), /*#__PURE__*/_jsx(Redirect, {
      from: path,
      to: `${path}${routes.associations}`
    })]
  });
}